<div class="facet-header d-flex justify-content-between align-items-center px-6 py-1" *ngIf="blockName"
     [ngClass]="{'expanded' : expanded}"
     (click)="toggleOpenState(!expanded)"
     (keydown.space)="toggleOpenState(!expanded)"
     (keydown.enter)="toggleOpenState(!expanded)"
     [attr.aria-expanded]="expanded"
     tabindex="0"
     role="button">
  <h3
    class="facet-header__label m-0 my-2"
    [attr.aria-label]="blockName | translate"
  >{{blockName | translate}}</h3>
  <span class="mr-n1"
        [ngClass]="expanded ? 'icon-angle-up-thin' : 'icon-angle-down-thin'">
    </span>
</div>
<div [ngbCollapse]="!expanded">
  <ng-content></ng-content>
</div>
